module.exports = __webpack_public_path__ + "static/the-kite-runner-533c86f7ef8a0a8d980d2486d6fdfeda.jpg";